export const SCORE_COLORS = {
  good: "text-success",
  warn: "text-warning",
  bad: "text-critical",
};

export function scoreClass(s) {
  if (s == null) return "text-ink-muted";
  if (s >= 80) return "text-success";
  if (s >= 50) return "text-warning";
  return "text-critical";
}

export function scoreBg(s) {
  if (s == null) return "bg-ink-muted";
  if (s >= 80) return "bg-success";
  if (s >= 50) return "bg-warning";
  return "bg-critical";
}

export function scoreLabel(s) {
  if (s == null) return "—";
  if (s >= 80) return "Healthy";
  if (s >= 50) return "Needs Work";
  return "Critical";
}

export function statusPill(status) {
  return {
    pass: { label: "PASS", cls: "border-success text-success bg-success/5" },
    warn: { label: "WARN", cls: "border-warning text-warning bg-warning/5" },
    fail: { label: "FAIL", cls: "border-critical text-critical bg-critical/5" },
  }[status] || { label: status?.toUpperCase() || "—", cls: "border-ink-muted text-ink-muted" };
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      month: "short", day: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function shortUrl(url) {
  if (!url) return "";
  try {
    const u = new URL(url.startsWith("http") ? url : `https://${url}`);
    return u.hostname + (u.pathname !== "/" ? u.pathname : "");
  } catch {
    return url;
  }
}
